import Icon from "../Icon";

const DownloadElements = ({ chart }) => {

    const downloadCSV = () => {
        if (chart && chart.current && chart.current.chart) {
            chart.current.chart.downloadCSV();
        }
    };
    const downloadPNG = () => {
        if (chart && chart.current && chart.current.chart) {
            chart.current.chart.exportChartLocal();
        }
    };
    return (<div id="export-container">

        <button
            className={`button btn btn-primary`}
            onClick={downloadPNG}><Icon icon="png" className={"white"} />
        </button>
        <button
            className={`button btn btn-primary`}
            onClick={downloadCSV}><Icon icon="csv" className={"white"} />
        </button>

    </div>)
}

export default DownloadElements;

